/* eslint-disable max-len */
import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { userHasMemberRole } from '../../services/apps/side-menu-builders/SideMenuHelper';

const RespondentDeletionRules = ({ account, toggleEdit, role }) => {
  const { formatMessage } = useIntl();

  const i18n = defineMessages({
    manual: {
      id: 'dashboard.respondents.deletionRule.manual',
      defaultMessage: 'Delete manually',
    },
    afterDays: {
      id: 'dashboard.respondents.deletionRule.afterDays',
      defaultMessage: '{numberOfDaysToAnonymizeAfter} days after completion',
    },
  });

  const {
    isHeadOfFamily,
    respondentData: { internalRespondents, externalRespondents },
  } = account;

  const {
    deletionRule: {
      type: internalRespondentsRuleType,
      numberOfDaysToAnonymizeAfter: anonymizeInternalRespondentsAfterDays,
    },
  } = internalRespondents;
  const {
    deletionRule: { numberOfDaysToAnonymizeAfter: anonymizeExternalRespondentsAfterDays },
  } = externalRespondents;

  const internalRespondentsDeletionRule = internalRespondentsRuleType === 'MANUAL'
    ? formatMessage(i18n.manual)
    : formatMessage(i18n.afterDays, { numberOfDaysToAnonymizeAfter: anonymizeInternalRespondentsAfterDays });
  const externalRespondentsDeletionRule = formatMessage(i18n.afterDays, {
    numberOfDaysToAnonymizeAfter: anonymizeExternalRespondentsAfterDays,
  });

  const getPermissionToEdit = () => {
    if (isHeadOfFamily) {
      return !userHasMemberRole(role);
    }

    return false;
  };

  const hasPermissionToEdit = getPermissionToEdit();

  return (
    <div>
      <Panel
        header={(
          <div className="p-grid p-nogutter">
            <div className="p-col">
              <FormattedMessage id="menu.respondent-deletion-rules" defaultMessage="Respondent deletion rules" />
            </div>
            <div className="p-col-2 align-right">
              {hasPermissionToEdit && (
                <Button
                  icon="fa fa-pencil"
                  type="button"
                  className="p-button-secondary p-button-sm"
                  onClick={toggleEdit}
                />
              )}
            </div>
          </div>
        )}
      >
        <div>
          <FormattedMessage
            id="settings.internal-respondents.deletionRules"
            defaultMessage="Internal Respondents: "
            tagName="strong"
          />
          <span>{internalRespondentsDeletionRule}</span>
        </div>
        <div>
          <FormattedMessage
            id="dashboard.external-respondents.deletionRules"
            defaultMessage="External Respondents: "
            tagName="strong"
          />
          <span>{externalRespondentsDeletionRule}</span>
        </div>
      </Panel>
    </div>
  );
};

RespondentDeletionRules.propTypes = {
  account: PropTypes.objectOf(PropTypes.any).isRequired,
  role: PropTypes.string.isRequired,
  toggleEdit: PropTypes.func.isRequired,
};

export default RespondentDeletionRules;
